var swiper = new Swiper(".product_slider_thumb", {
  slidesPerView: 4,
  spaceBetween: 10,
  breakpoints: {
    640: {
      slidesPerView: 6,
      spaceBetween: 15,
    },
  },
});
var swiper2 = new Swiper(".product_slider", {
  spaceBetween: 1,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiper,
  },
});

var swiper = new Swiper(".testimonial_col_slider", {
  slidesPerView: 3,
  direction: 'vertical',
  mousewheel: true,
  grabCursor: true,
  spaceBetween: 20,
   navigation: {
    nextEl: ".testimonial_info .swiper-button-next"
  },
});

var famaliy_slider = new Swiper(".famaliy_slider", {
  slidesPerView: 1,
  spaceBetween: 30,
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
  },
});

// var videoslider = new Swiper(".zaf_video_slider", {
//   speed: 5000,
//   loop: true,
//   loopAdditionalSlides: 6,
//   slidesPerView: 8,
//   spaceBetween: 15,
//   autoplay: {
//     delay: 0,
//     disableOnInteraction: false,
//   },
// });

// var videoslider = new Swiper(".zaf_video_marquee", {
//   slidesPerView: 8,         
//   spaceBetween: 15,
//   direction: "horizontal",
//   loop: true,
//   // loopAdditionalSlides: 8,   
//   // speed: 3000,               
//   // autoplay: {
//   //   delay: 0,                
//   //   disableOnInteraction: false,
//   // },
//   // allowTouchMove: false,      
//   // freeMode: true,            
//   // freeModeMomentum: false, 
// });

var videoslider = new Swiper(".zaf_video_marquee", {
  slidesPerView: 3.8,
  spaceBetween: 10,
  slidesPerGroup: 1,
  centeredSlides: true,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next.zaf_video_marquee_arrow",
    prevEl: ".swiper-button-prev.zaf_video_marquee_arrow",
  },
  on: {
    init: function () {
      const swiper = this
      swiper.slides.forEach(slide => {
  slide.addEventListener('click', (e) => {
    const btn = e.target.closest('.video-act-btn svg');
    if (!btn) return;

    swiper.slides.forEach(s => {
      const video = s.querySelector('video');
      if (!video) return;

      // MUTE
      if (btn.classList.contains('mute')) {
        s.querySelector('.video-act-btn svg.mute').style.display = 'none';
        s.querySelector('.video-act-btn svg.unmute').style.display = 'block';
        video.muted = true;
      }

      // UNMUTE
      if (btn.classList.contains('unmute')) {
        video.muted = false;
        s.querySelector('.video-act-btn svg.mute').style.display = 'block';
        s.querySelector('.video-act-btn svg.unmute').style.display = 'none';
      }
    });
  });
});

  },

    slideChange: function () {
      this.slides.forEach(slide => {
        const video = slide.querySelector('video');
        if (video) video.pause();

         if ( slide.classList.contains('swiper-slide-prev') || slide.classList.contains('swiper-slide-next')) {
            if (video.preload !== 'auto')  video.preload = 'auto';
            }
         });

       const activeVideo = this.slides[this.activeIndex].querySelector('video');
       if (activeVideo) activeVideo.play().catch(() => {});
    }
  },
   breakpoints: {
    0: {          
      slidesPerView: 1.8,
      spaceBetween: 10,
    },
    767: {        
      slidesPerView: 1.8,
      spaceBetween: 10,
    },
    1280: {        
      slidesPerView: 3.8,
      spaceBetween: 10,
    }
  }
});

var new_testimonial = new Swiper(".new_testimonial_slider", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".new_testimonial_inner .swiper-button-next",
    prevEl: ".new_testimonial_inner .swiper-button-prev",
  },
  breakpoints: {
    675: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    1080: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
});

$(".bundle_accordion_title").click(function () {
  $(".bundle_accordion_title").removeClass("active");
  $(".bundle_accordion_content_wp").slideUp();
  if (!$(this).next().is(":visible")) {
    $(this).next().slideDown();
    $(this).addClass("active");
  }
});

$(".faq_accordion_title").click(function () {
  $(".faq_accordion_title").removeClass("active");
  $(".faq_accordion_content_wp").slideUp();
  if (!$(this).next().is(":visible")) {
    $(this).next().slideDown();
    $(this).addClass("active");
  }
});
$("body").on("click", ".pdp_qty_btn .qty_btn", function () {
  var input = $(this).parent().find("input");
  var ip = parseInt(input.val());
  if ($(this).hasClass("plus")) {
    ip = ip + 1;
  } else {
    ip = ip - 1;
  }
  if (ip == 0) {
    ip = 1;
  }
  input.val(ip);
});
$("body").on("change", ".pdp_qty_btn input", function (event) {
  var input = $(this);
  var value = parseInt(input.val());
  if (event.type === "keydown") {
    if (event.key === "ArrowUp") {
      input.val(value + 1);
      event.preventDefault();
    } else if (event.key === "ArrowDown") {
      input.val(value > 1 ? value - 1 : 1);
      event.preventDefault();
    }
  }
  if (input.val() == 0) {
    input.val(1);
  }
});


  $('.how_to_btn, [scroll-to-pdp]').on('click', function (event) {

    const $btn = $(this);

    $btn.addClass('clicked');

    setTimeout(function () {
      $btn.removeClass('clicked');
    }, 300);

    if ($btn.attr('href') === '#') {
      event.preventDefault();
      // const scrollTarget = $('subscription-box').length ? $('subscription-box').offset().top : $('.product_info').offset().top;

      const scrollTarget = $('.product_hero_section').offset().top;

      $('html, body').animate({
        scrollTop: scrollTarget
      }, 500);
    }

  });

var supplement_slider = new Swiper('.supplement-slider', {
  slidesPerView: 1,
  spaceBetween: 20,
  navigation: {
    nextEl: '.swiper-button-next.supplement-slider_arrow',
    prevEl: '.swiper-button-prev.supplement-slider_arrow',
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    992: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
  },
});

var before_decide_slider = new Swiper('.before_decide_slider', {
  slidesPerView: 1.2,
  spaceBetween: 10,
  slidesOffsetAfter: 10,
  breakpoints: {
    0: {
      slidesPerView: 1.2,
      spaceBetween: 10,
      slidesOffsetAfter: 10,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    1281: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
});

var magic_formula_slider = new Swiper('.magic_formula_slider', {
  slidesPerView: 1.2,
  spaceBetween: 10,
  slidesOffsetAfter: 10,
  breakpoints: {
    0: {
      slidesPerView: 1.2,
      slidesOffsetAfter: 10,
      spaceBetween: 10,
    },
    767: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    1025: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
});

var slider_blocks = new Swiper('.slider_blocks', {
  slidesPerView: 2,
  slidesPerGroup: 1,
  centeredSlides: true,
  spaceBetween: 10,
  loop: true,
  on: {
    init: function () {
      const swiper = this;
      swiper.slides.forEach((slide) => {
        slide.addEventListener('click', (e) => {
          const btn = e.target.closest('.video-act-btn svg');
          if (!btn) return;

          swiper.slides.forEach((s) => {
            const video = s.querySelector('video');
            if (!video) return;

            // MUTE
            if (btn.classList.contains('mute')) {
              s.querySelector('.video-act-btn svg.mute').style.display = 'none';
              s.querySelector('.video-act-btn svg.unmute').style.display = 'block';
              video.muted = true;
            }

            // UNMUTE
            if (btn.classList.contains('unmute')) {
              video.muted = false;
              s.querySelector('.video-act-btn svg.mute').style.display = 'block';
              s.querySelector('.video-act-btn svg.unmute').style.display = 'none';
            }
          });
        });
      });
    },

    slideChange: function () {
      this.slides.forEach((slide) => {
        const video = slide.querySelector('video');
        if (!video) return;
        if (video) video.pause();

        if (slide.classList.contains('swiper-slide-prev') || slide.classList.contains('swiper-slide-next')) {
          if (video.preload !== 'auto') video.preload = 'auto';
        }
      });

      const activeVideo = this.slides[this.activeIndex].querySelector('video');
      if (activeVideo) activeVideo.play().catch(() => {});
    },
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
  },
});


var pdp = document.querySelector('product-info');
  if (pdp) {
      window.addEventListener('scroll', () => {
        let submitBtn = pdp.querySelector('subscription-box');
        let stickyBottom = document.querySelector('.sticky_bottom');
        if (!submitBtn || !stickyBottom) return;

        let submitRect = submitBtn.getBoundingClientRect();

        let submitVisible = submitRect.top < window.innerHeight && submitRect.bottom > 0;

        if (!submitVisible) {
          stickyBottom.classList.add('active-sticky');
          stickyBottom.setAttribute('style', 'position: fixed; bottom: 0; left: 0; width: 100%;');
        } else {
          stickyBottom.classList.remove('active-sticky');
          stickyBottom.style.position = 'relative';
        }
      });
    }

// Popup js
var popup_target_btn = document.querySelectorAll('[data-target-popup]'); 

popup_target_btn.forEach((ele) => {
  ele.addEventListener('click', function (e) {
    var popupTargetId = e.target.getAttribute('data-target-popup');
    if (popupTargetId) {
      e.preventDefault();
      document.querySelector(`#${popupTargetId}`).classList.add('open');
    }
  });
});
document.addEventListener('click', function (e) {
  if (
    (!e.target.closest('.popup-content') && !e.target.closest('[data-target-popup]')) ||
    e.target.closest('[data-popup-close]')
  ) {
    document.querySelectorAll('.popup-outer').forEach((item) => {
      item.classList.remove('open');
    });
  }
});
